import { useCustom } from '@refinedev/core';

import { AvailableResources } from '@/config';
import { DEFAULT_STALE_TIME } from '@/constants';

import type { GetWorkersParams, WorkersResponse } from './types';

export const useGetWorkers = (params: GetWorkersParams) => {
  const planningRegionId = params.planning_region_id ?? '';
  const source = params.source || 'PANORAMA';
  const { data, isLoading, error } = useCustom<WorkersResponse>({
    url: AvailableResources.WORKERS_SIMPLIFIED,
    method: 'get',
    queryOptions: {
      enabled: Boolean(planningRegionId),
      retry: false,
      staleTime: DEFAULT_STALE_TIME,
      // Stable, explicit key so worker mutations elsewhere can invalidate it.
      queryKey: [
        AvailableResources.WORKERS_SIMPLIFIED,
        planningRegionId,
        source
      ]
    },
    config: {
      query: {
        planning_region_id: planningRegionId,
        source
      }
    }
  });

  return {
    data: data?.data,
    isLoading,
    error
  };
};
